import { render, staticRenderFns } from "./RenalCystic.vue?vue&type=template&id=4f548308"
import script from "./RenalCystic.vue?vue&type=script&lang=js"
export * from "./RenalCystic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports